import React, { useState} from 'react'
import Navbar1 from './components/Navbar'
import FilmComp from './components/FilmComp'
import Sidebar from './components/Sidebar'
import MobileNav1 from './components/MobileNav1';



function App() {

  const [currentCategory, setCurrentCategory] = useState('popular'); // Default category
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const handleCategoryChange = (category) => {
    setCurrentCategory(category);
    setIsMobileNavOpen(false);
  };


  return (
    <div>
      <div>
      <Navbar1 />
      
      </div>
        <div>
      {/* Sidebar with buttons */}
      <Sidebar onCategoryChange={handleCategoryChange} />

          <div>
            <MobileNav1 onCategoryChange={handleCategoryChange} 
            isMobileNavOpen={isMobileNavOpen}
            />
            <FilmComp currentCategory={currentCategory} />
          </div>
        </div>
    </div>
  )
}

export default App
